import { InjectionToken } from '@angular/core';

export interface LogRocketConfiguration {
  logRocketProjectKey: string;
  logRocketSessionCaptureEnabled: boolean;
}

export const LOG_ROCKET_CONFIGURATION = new InjectionToken<LogRocketConfiguration>('LogRocketConfiguration');
